export enum PhotoPreview {
  Horizontal = 0,
  Vertical = 1,
  Quadrangle = 2,
};
